import { AdContainer } from "./ad-container";

interface SidebarAdProps {
  slot?: string;
  className?: string;
}

export function SidebarAd({ slot, className }: SidebarAdProps) {
  return <AdContainer format="vertical" slot={slot} className={className} />;
}
